/**
 * @file ShopCreateSummary.tsx
 * @description Блок «Что произойдёт» формы «Новый магазин» (phase19.28
 * этап А; uiux-platform-shops §3; PL6 стартовый набор, PL7, PL8, PL10).
 *
 * Состав стартового набора — реестром `STARTER_SET` (PL6): что создаётся и
 * чего не копируют от Chaiberi. Поменялось правило — меняется запись.
 */

import { buildSubdomainHost, validateShopSlug } from "@chaiberi/shared";

import { usePlatformEdgeConfig } from "../../../hooks/platform/usePlatformEdgeConfig";

/** PL6: что создаётся у нового магазина. */
const STARTER_SET = [
  "виды товара",
  "воронки заказов и возвратов",
  "системные шаблоны писем с названием магазина",
  "CRM-воронка для покупателей",
  "стартовый сайт: страницы «Главная», «Доставка и оплата», «Возврат и обмен», «Контакты» — черновиками",
  "черновики юр. документов — без текста, не опубликованы",
] as const;

export function ShopCreateSummary({ slug, invite }: { slug: string; invite: boolean }) {
  const { baseDomain } = usePlatformEdgeConfig();
  const host = validateShopSlug(slug).data ? buildSubdomainHost(slug, baseDomain) : `‹slug›.${baseDomain}`;
  return (
    <section aria-labelledby="shop-create-summary" className="flex flex-col gap-2 rounded-xl bg-surface-low p-4">
      <h2 id="shop-create-summary" className="type-card-title">
        Что произойдёт
      </h2>
      <ul className="type-body flex list-disc flex-col gap-1 pl-5 text-on-surface">
        <li className="break-words">
          адрес <span className="break-all">{host}</span> — DNS уже готов (*.{baseDomain})
        </li>
        <li>пустой сайт в теме платформы, закрыт до запуска</li>
        <li>{invite ? "владельцу уйдёт приглашение на 7 дней, роль «Владелец магазина»" : "владелец получит роль «Владелец магазина»"}</li>
        <li>создаются: {STARTER_SET.join("; ")}</li>
        <li>не копируются: вид сайта, каталог, перевозчики и реквизиты другого магазина</li>
      </ul>
    </section>
  );
}
